import { axiosInstance } from "./axiosInstance";

export const createOrder = async (data: any) => {
    const response = await axiosInstance.post("/api/orders", data);
    return response.data;
};

export const getMyOrders = async () => {
    const response = await axiosInstance.get("/api/orders");
    return response.data;
};

export const getOrderDetail = async (orderNo: string) => {
    const response = await axiosInstance.get(`/api/orders/${orderNo}`);
    return response.data;
};

export const createAdminOrder = async (data: any) => {
    const response = await axiosInstance.post("/api/admin/orders", data);
    return response.data;
};

// 기존 파일 하단에 추가해 주세요!
export const getGuestOrderDetail = async (payload: { orderNo: string, orderPassword: string }) => {
    const response = await axiosInstance.post('/api/orders/guest/detail', payload)
    return response.data
}
